// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "integration_gitlab-" + chunkId + ".js?v=" + {"vendors-node_modules_vue-material-design-icons_OpenInNew_vue-node_modules_nextcloud_moment_di-419cc7":"7ac20b69fc4338769247","reference-lazy":"9717485c3b9c6edf1f9d"}[chunkId] + "";
};